'use client';

import { t } from '@lingui/macro';
import toast from 'react-hot-toast';
import { saveResponseAsFile } from '../utils/save-response-as-file';
import { composePdfUrl } from './compose-pdf-url';
import { ParamsSchema, type ParamsSchemaT } from './schema';

export const fetchDiagnosticPdfAction = async (params: ParamsSchemaT) => {
  const { project, locale } = ParamsSchema.parse(params);

  const toastId = `download-pdf-project-toast-${project.id}-${locale}`;

  try {
    toast.loading(t`${project.name}: Préparation du rapport...`, {
      id: toastId,
    });

    const result = await composePdfUrl(params);

    if (!result?.data) {
      throw new Error();
    }

    const { data: url } = result;

    const headers = new Headers();
    headers.set('Content-Type', 'application/json');

    const response = await toast.promise(
      fetch(url, {
        method: 'GET',
      }),
      {
        loading: t`${project.name}: Génération du rapport en cours...`,
        success: t`${project.name}: Génération réussie`,
        error: t`${project.name}: Une erreur est survenue lors de la génération.`,
      },
      {
        id: toastId,
      }
    );

    if (!response.ok) {
      throw new Error();
    }

    await toast.promise(
      saveResponseAsFile(response, `Rapport collectif - ${project.name}.pdf`),
      {
        loading: t`${project.name}: Préparation du téléchargement...`,
        success: t`${project.name}: Téléchargement réussi`,
        error: t`${project.name}: Une erreur est survenue lors du téléchargement.`,
      },
      {
        id: toastId,
      }
    );
  } catch (error) {
    toast.error(t`${project.name}: Une erreur est survenue...`, {
      id: toastId,
    });
    throw error;
  }
};
